/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FormAnswerItem } from "./FormAnswerItem";

/**
 * The answers about one person.
 */
export type FormAnswerBlock = {
  section: FormAnswerBlock.section;
  title: string;
  person_id?: number | null;
  created?: boolean;
  items: Array<FormAnswerItem>;
};

export namespace FormAnswerBlock {
  export enum section {
    PARENT = "parent",
    STUDENT = "student",
    TUTOR = "tutor",
  }
}
